module.exports = __webpack_public_path__ + "static/media/amulet_12.6301701c.png";